import { Mapper } from '../../../../base/utils/mapper';
import { JITMeetEligibilityModel } from '../../../../domain/models/jit-meet/jit-meet-eligibility.model';
import { JITMeetEligibilityEntity } from '../entities/jit-meet-eligibility.entity';

export class JITMeetEligibilityRepositoryMapper extends Mapper<
  JITMeetEligibilityEntity,
  JITMeetEligibilityModel
> {
  mapFrom(param: JITMeetEligibilityEntity): JITMeetEligibilityModel {
    return {
      ...param,
      data: param.data
        ? {
            ...param.data,
            advertencias: param.data.advertencias ?? [],
          }
        : null,
    };
  }

  mapTo(param: JITMeetEligibilityModel): JITMeetEligibilityEntity {
    return {
      ...param,
      data: param.data
        ? {
            ...param.data,
            advertencias: param.data.advertencias ?? [],
          }
        : null,
    };
  }
}